"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeblabContext = void 0;
/**
 * Interface for weblab context, that will be used to resolve the weblab treatment.
 */
var WeblabContext = /** @class */ (function () {
    function WeblabContext(options) {
        if (options === void 0) { options = {}; }
        this.marketplaceId = options.marketplaceId;
        this.sessionId = options.sessionId;
        this.customerId = options.customerId;
    }
    return WeblabContext;
}());
exports.WeblabContext = WeblabContext;
exports.default = WeblabContext;
